import { Card } from "@/components/ui/card";
import { kelompokkanBreakdown, jumlahDariBaris } from "@/lib/orientasiBreakdown";

// Kelompok per jenjang (Spesialis, Subspesialis, Koas); tiap kelompok: judul + subjumlah,
// lalu prodi yg jumlahnya > 0. Tabel mengalir biasa di dalam kartu (tanpa kotak gulir & tanpa sticky:
// halaman sudah punya blok atas yg menempel, jadi sticky/gulir kedua menumpuk & memotong baris).
export default function BreakdownProdiOrientasi({ rows, jumlah, judulKolom }) {
    const total = (jumlah || jumlahDariBaris(rows)).total;
    const kelompok = kelompokkanBreakdown(rows);
    return (
        <Card className="lg:col-span-2 border-slate-200 shadow-sm overflow-hidden" data-testid="orientasi-breakdown">
            <div className="px-4 py-2 border-b bg-slate-50 text-xs font-semibold text-slate-600">
                Breakdown per {judulKolom}
            </div>
            <div className="overflow-x-auto">
                <table className="w-full compact">
                    <thead className="bg-slate-100">
                        <tr className="text-left text-xs uppercase tracking-wider text-slate-600 font-semibold">
                            <th>{judulKolom}</th><th className="text-right pr-4">Jumlah</th>
                        </tr>
                    </thead>
                    {kelompok.map((k) => (
                        <tbody key={k.kunci} data-testid={`orientasi-kelompok-${k.kunci}`}>
                            <tr className="bg-slate-50 border-t border-slate-300 font-bold text-slate-900" data-testid="orientasi-kelompok-judul">
                                <td>
                                    {k.judul}
                                    {k.subjumlah === 0 && <span className="font-normal text-slate-400">{" "}belum ada</span>}
                                </td>
                                <td className="text-right pr-4">{k.subjumlah}</td>
                            </tr>
                            {k.prodi.map((p) => (
                                <tr key={p.prodi_id} data-testid="orientasi-breakdown-baris" className="border-t border-slate-200 hover:bg-slate-50">
                                    <td className="pl-6 text-slate-800">{p.nama}</td>
                                    <td className="text-right pr-4 text-slate-700">{p.jumlah}</td>
                                </tr>
                            ))}
                        </tbody>
                    ))}
                    <tfoot className="bg-slate-100" data-testid="orientasi-breakdown-jumlah">
                        <tr className="border-t-2 border-slate-300 font-bold text-slate-900">
                            <td>Jumlah keseluruhan</td>
                            <td className="text-right pr-4">{total}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </Card>
    );
}
